// extracted by mini-css-extract-plugin
module.exports = {"main-container":"userEvents-module__main-container__1ZmOV","sub-header":"userEvents-module__sub-header__BWAuB","events-wrapper":"userEvents-module__events-wrapper__q7umW"};